import { Facility } from '@reliance/types/models/Facility';
import React from 'react';
import FacilityEquipmentList from '../facility-equipment/list/List';

type FacilityEquipmentTabProps = {
  facility: Facility;
};

const FacilityEquipmentTab: React.FC<FacilityEquipmentTabProps> = ({ facility }) => {
  return (
    <div className="jarviswidget jarviswidget-color-blueDark">
      <div className="content">
        <FacilityEquipmentList facilityId={facility.id} />
      </div>
    </div>
  );
};

export default FacilityEquipmentTab;
